import React, { useEffect } from "react";
import AnimationPlayer from "../../Common/Animation-Player/AnimationPlayer";
import ErrorPageAnimation from "../../Assets/Json/nodata-found-robot-animation.json";
import Button from "../../Common/Button/Button";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import "../../Common/Common.css";

const StyledErrorContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  // marginTop: "-3vw",
  marginBottom: "5vw",
});

const StyledExistMessage = styled("h2")({
  color: "#6940b4",
});

function ErrorPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const originalBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalBodyOverflow;
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100vw",
        flexDirection: "column",
      }}
    >
      <div
        className="login-animation"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AnimationPlayer
          animationSrc={ErrorPageAnimation}
          playerHeight="35%"
          playerWidth="300px"
          // playerMarginTop="40px"
        />
        <StyledErrorContainer className="error-div">
          <StyledExistMessage className="exist">
            The Page You're looking for doesn't exist
          </StyledExistMessage>

          <Button
            className="Upload-btn"
            event={() => navigate("/dashboard")}
            label="Go To Dashboard"
            style={{padding:"10px 15px"}}
          />
        </StyledErrorContainer>
      </div>
    </div>
  );
}

export default ErrorPage;
